import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface SelectedCompanyState {
  selectedCompanyId: string | null;
  setSelectedCompany: (companyId: string | null) => void;
  clearSelectedCompany: () => void;
}

const STORAGE_KEY = 'adn-selected-company';

export const useSelectedCompanyStore = create<SelectedCompanyState>()(
  persist(
    (set) => ({
      selectedCompanyId: null,
      setSelectedCompany: (companyId) => set({ selectedCompanyId: companyId }),
      clearSelectedCompany: () => set({ selectedCompanyId: null }),
    }),
    {
      name: STORAGE_KEY,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ selectedCompanyId: state.selectedCompanyId }),
    },
  ),
);
